import React, { useState } from 'react';
import { Form, Select, Button, DatePicker, message } from 'antd';
import { requiredRule } from 'utils/forms/validationRules';
import { paymentTypesArr } from 'utils/handbooks/paymentsHandbook';
import { PaymentsService } from 'services/PaymentsService';
import { REQUEST_LOADING } from 'constants/alerts';
import { CONTENT_SPAN, LABEL_SPAN } from 'constants/table';
import { fullWidthStyle } from 'utils';
import dayjs from 'dayjs';

function GeneratePaymentForm({ onSuccess, clientId, clients = [] }) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    const { id, bin_iin } = clients.find((el) => el.id === clientId);

    const payload = {
      ...values,
      post_clients: [{ id, bin_iin }],
      post_period: values.post_period.format('YYYY-MM'),
    };

    const hide = message.loading(REQUEST_LOADING);
    setLoading(true);

    try {
      const data = await PaymentsService.generatePayment(payload);

      if (Array.isArray(data)) {
        data.forEach((mes) => {
          if (mes?.detail) {
            message.warning(mes?.detail, 5);
          }
        });
      }
      if (data) {
        message.success('Платеж успешно сформирован');
        form.resetFields();
        onSuccess();
      }
    } catch (err) {
      message.error('Не удалось сформировать платеж');
    } finally {
      setLoading(false);
      hide();
    }
  };

  const getFilteredPaymentTypes = () => {
    return paymentTypesArr.filter(
      (type) => type.value !== 'accounting' && type.value !== 'service'
    );
  };

  return (
    <Form
      form={form}
      onFinish={handleSubmit}
      layout="horizontal"
      labelCol={{
        span: LABEL_SPAN,
      }}
      wrapperCol={{ span: CONTENT_SPAN }}
      labelAlign="right"
      initialValues={{
        post_types: ['ipn', 'opv', 'so', 'vosms', 'osms', 'opvr'],
        post_period: dayjs(),
      }}
    >
      <Form.Item name="post_types" label="Тип платежа" rules={[requiredRule]}>
        <Select
          mode="multiple"
          placeholder="Выберите тип платежа"
          showArrow
          allowClear
        >
          {getFilteredPaymentTypes().map(({ value, text }) => (
            <Select.Option key={value} value={value}>
              {text}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item name="post_period" label="Период" rules={[requiredRule]}>
        <DatePicker
          picker="month"
          format="MM.YYYY"
          style={fullWidthStyle}
          placeholder="Выберите период"
        />
      </Form.Item>

      <Form.Item wrapperCol={{ offset: CONTENT_SPAN }}>
        <Button type="primary" htmlType="submit" loading={loading}>
          Сформировать
        </Button>
      </Form.Item>
    </Form>
  );
}

export { GeneratePaymentForm };
